/*
 * @Author: your name
 * @Date: 2021-08-26 09:49:59
 * @LastEditTime: 2021-10-19 18:20:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/router/wechatBinding.js
 */
const wechatBindingIndex = () => import('@/pages/wechatBinding/wechatBindingIndex.vue');// 绑定微信服务号
const toBind = () => import('@/pages/wechatBinding/toBind.vue');// 绑定微信服务号

export default [
  {
    path: '/wechatBindingAccount',
    name: 'wechatBindingAccount',
    component: wechatBindingIndex,
  }, {
    path: '/wechatUnBindingAccount',
    name: 'wechatUnBindingAccount',
    component: wechatBindingIndex,
  }, {
    path: '/toBind',
    name: 'toBind',
    component: toBind,
  },
];
